import { SmartfireComponent, smartProps } from "@smartfire/gutenberg-react";
import "./style.scss";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import { PanelBody, Panel } from "@wordpress/components";
import Typography from "@material-ui/core/Typography";
import Blocklist from "../blocklist/block.js";
import CapsaTitle from "../CapsaTitle/block.js";
import apiFetch from "@wordpress/api-fetch";

export default class RelatedProductsBlock extends SmartfireComponent {
  static smartProps = {
    categories: smartProps.any.withDefault([]),
    products: smartProps.any.withDefault([]),
  };

  constructor(props) {
    super(props);
    this.state = {
      products: [],
      categories: [],
      loading: true,
    };
  }

  componentWillMount() {
    if (this.isEditing) {
      apiFetch({ path: "/wp/v2/all-terms?term=product-category" }).then(
        (terms) => {
          this.setState({ categories: terms });
        }
      );
    } else {
      apiFetch({
        path: `/wp/v2/products?cat=${this.props.categories.join(",")}`,
      }).then((products) => {
        this.setState({ products: products, loading: false });
      });
    }
  }

  render() {
    if (this.isEditing) {
      return this.renderEdit();
    }
    if (this.state.loading) return <div />;
    return (
      <div className="related-products-block">
        <div className="content-container">
          <CapsaTitle title="Produits concernés" position="center" bg="white" />
        </div>
        <Blocklist
          blocks={this.state.products}
          type="related"
          itemsPerRow={4}
          phone={window.websiteInfo ? window.websiteInfo.phone : undefined}
        />
      </div>
    );
  }

  product(id) {
    const product = this.state.products.filter((p) => p.id === id)[0] || null;
    if (product === null) console.error("Product " + id + " can not be found");
    return product;
  }

  category(id) {
    const category =
      this.state.categories.filter((c) => c.term_id === id)[0] || null;
    if (category === null)
      console.error("Category " + id + " can not be found");
    return category;
  }

  renderEdit() {
    return (
      <Panel>
        <PanelBody>
          <Typography variant="subtitle1">Produits concernés</Typography>
          <FormControl style={{ width: "100%", minHeight: "1.75em" }}>
            <InputLabel htmlFor="select-multiple-chip">
              Catégorie(s) de produits à afficher
            </InputLabel>
            <Select
              multiple
              value={this.props.categories || []}
              onChange={(e) =>
                this.setAttributes({ categories: e.target.value })
              }
              input={<Input id="select-multiple-chip" />}
              renderValue={(selected) => (
                <div>
                  {selected.length <= 0 ? (
                    <div>
                      <Chip label={"Aucun produit selectionné"} />
                    </div>
                  ) : (
                    selected.map((term_id) => (
                      <Chip
                        key={term_id}
                        label={
                          this.category(term_id)
                            ? this.category(term_id).name
                            : "Loading..."
                        }
                      />
                    ))
                  )}
                </div>
              )}
            >
              {this.state.categories.map((c) => (
                <MenuItem key={c.term_id} value={c.term_id}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </PanelBody>
      </Panel>
    );
  }
}
